import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_378: DocMigration = {
  maxSchemaVersion: "0.0.378",
  description: "Update intersection condition choices to support `cartesianProductAtSet`",
  apply(json: any) {
    for (const optionSetId in json.optionSets) {
      const optionSet = json.optionSets[optionSetId];
      if (optionSet.optionSetType === "INTERSECTING" && optionSet.conditions) {
        optionSet.conditions = Object.fromEntries(
          Object.values(optionSet.conditions).map(({ parentId, choices }: any) => {
            return [
              parentId,
              {
                parentId,
                // { "A": "B", "C": "D" } => { "A": ["B"], "C": ["D"] }
                choices: Object.fromEntries(Object.entries(choices).map(([key, value]: any) => [key, [value]])),
              },
            ];
          }),
        );
      }
    }
    return json;
  },
};

export default migration_0_0_378;
